import { useQuery, QueryOptions } from 'react-query';
import useAbortController from '../useAbortController';
import AffordaPortalFormsService from '../../services/affordaPortalFormsService';
import useSelectedProperty from '../useSelectedProperty';

const useCheckFormExistsQuery = ({
  portalUserId,
  options = {},
}: {
  organizationId: string,
  propertyId: string,
  portalUserId: string,
  options?: QueryOptions,
} = {}) => {
  const { organizationId, id: propertyId } = useSelectedProperty();

  const abortControllerOptions = useAbortController();
  const queryKey = [
    'checkFormExists',
    organizationId,
    propertyId,
    portalUserId,
  ];

  return useQuery(
    queryKey,
    async () => {
      const service = new AffordaPortalFormsService();
      return service.checkFormExists({
        organizationId,
        propertyId,
        portalUserId,
        options: abortControllerOptions,
      });
    },
    { refetchOnWindowFocus: false, ...options },
  );
};

export default useCheckFormExistsQuery;
